export default __webpack_public_path__ + "static/media/AC_converter.d9b4a800.PNG";